export class GetSiteSetting {
  static readonly type = '[SiteSettings] Get';
}
